import { render } from "./AlunoNota.vue?vue&type=template&id=4cafde8e"
import script from "@/assets/js/alunoNota.js?vue&type=script&lang=js"
export * from "@/assets/js/alunoNota.js?vue&type=script&lang=js"

import "./AlunoNota.vue?vue&type=style&index=0&id=4cafde8e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__